module.exports = __webpack_public_path__ + "img/코엑스 고기집.95c956b1.png";